var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-modal',_vm._b({ref:"modal",attrs:{"variant":_vm.variant},on:{"hide":_vm.onModalHide,"hidden":_vm.onModalHidden}},'dialog-modal',_vm.$dialogsProps,false),[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }